import {
  SET_SURVEY_QUESTIONS,
  SET_SURVEY_QUESTIONS_ERROR,
  SET_SURVEY_ID,
  SET_SURVEY_SUBMIT_ERROR,
  SET_SURVEY_COMPLETED,
  CLEAR_SURVEY_STATE
} from '../actions'

export const surveyDefaults = {
  questions: [],
  displayOnClose: false,
  questionsError: false,
  surveyId: null,
  submitError: false,
  completedSurvey: false
}
export const surveyReducer = function (state = surveyDefaults, action) {
  switch (action.type) {
    case SET_SURVEY_QUESTIONS:
      return {
        ...state,
        questions: action.payload.questions,
        displayOnClose: action.payload.displayOnClose,
        questionsError: false
      }
    case SET_SURVEY_QUESTIONS_ERROR:
      return {
        ...state,
        questionsError: action.payload
      }
    case SET_SURVEY_ID:
      return {
        ...state,
        surveyId: action.payload,
        submitError: false
      }
    case SET_SURVEY_SUBMIT_ERROR:
      return {
        ...state,
        submitError: action.payload
      }
    case SET_SURVEY_COMPLETED:
      return {
        ...state,
        completedSurvey: action.payload
      }
    case CLEAR_SURVEY_STATE:
      return {
        ...surveyDefaults
      }
    default:
      return state
  }
}
